import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex-column-box work-manage-detail-digitalman flex-start" }
const _hoisted_2 = { class: "flex-column-box wrap radius-middle flex-start" }
const _hoisted_3 = {
  style: {"width":"100%","height":"50px","flex-grow":"2"},
  class: "flex-column-box flex-start"
}
const _hoisted_4 = { class: "flex-row-box demo-wrap flex-start" }
const _hoisted_5 = { class: "demo-content-wrap" }
const _hoisted_6 = { class: "flex-row-box flex-start" }
const _hoisted_7 = { class: "demo-item" }
const _hoisted_8 = { class: "sub-title-color flex-row-box" }
const _hoisted_9 = { class: "demo-item" }
const _hoisted_10 = { class: "sub-title-color flex-row-box" }
const _hoisted_11 = { class: "flex-column-box record-wrap" }
const _hoisted_12 = { style: {"margin-top":"1.2vh"} }
const _hoisted_13 = { class: "voice-demo-wrap" }
const _hoisted_14 = { style: {"width":"40px","flex-grow":"2"} }
const _hoisted_15 = { style: {"width":"40px","flex-grow":"2"} }
const _hoisted_16 = {
  class: "opt-wrap flex-row-box",
  style: {"justify-content":"flex-end"}
}

import {ref, onMounted, computed, reactive} from 'vue';
import { useRouter } from "vue-router";

// do not use same name with ref

export default /*@__PURE__*/_defineComponent({
  __name: 'digitalmanEffect',
  setup(__props) {

const form = reactive({
  name: '小娥',
  type: [],
  gender: '2',
  matting: 1,
  voiceName: '萧瑟数字人音色定制',
  voiceDemos:[
    {
      time: '2024-03-13  19:05:13',
      name: 'demo1'
    },{
      time: '2024-03-14  19:05:13',
      name: 'demo2'
    }
  ]
})


const router = useRouter();


const goBack = ()=>{
  router.go(-1);
}

const downloadDemo = ()=>{

}


onMounted(()=>{

})


return (_ctx: any,_cache: any) => {
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "flex-row-box header-box",
      onClick: goBack
    }, [
      _createVNode(_component_svgIcon, { iconClass: "arrowleft" }),
      _cache[5] || (_cache[5] = _createTextVNode("定制形象训练效果确认 "))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "title" }, "基础信息", -1)),
        _createVNode(_component_el_form, {
          model: form,
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "数智人名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "角色性别" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.gender,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.gender) = $event)),
                  placeholder: "",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "男",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "女",
                      value: "2"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "定制类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: form.type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.type) = $event)),
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      value: "1",
                      name: "1"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("定制形象")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, {
                      value: "2",
                      name: "2"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("定制音色")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[21] || (_cache[21] = _createElementVNode("p", { class: "title" }, "训练效果", -1)),
        _createVNode(_component_el_form, {
          model: form,
          inline: true,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "视频抠绿",
              style: {"width":"100%","margin":"0px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.matting,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.matting) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { value: 1 }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("需去背景(仅限绿幕素材)")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { value: 2 }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("无需去背景")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "note" }, "我方抠像后，可以通过数智人API服务更换视频背景图片", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "sub-title" }, "训练demo", -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "demo-item" }, [
                _createElementVNode("p", { class: "sub-title-color" }, "训练素材"),
                _createElementVNode("video", { src: "" })
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, [
                  _cache[12] || (_cache[12] = _createTextVNode("demo1 ")),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    plain: "",
                    size: "small",
                    onClick: downloadDemo
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("下载demo")
                    ])),
                    _: 1
                  })
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("video", { src: "" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, [
                  _cache[15] || (_cache[15] = _createTextVNode("demo2 ")),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    plain: "",
                    size: "small",
                    onClick: downloadDemo
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("下载demo")
                    ])),
                    _: 1
                  })
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("video", { src: "" }, null, -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_form, {
              model: form,
              inline: true,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "demo音色",
                  style: {"width":"100%","margin":"0px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.voiceName,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.voiceName) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createElementVNode("div", _hoisted_12, [
              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "sub-title" }, "训练记录", -1)),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.voiceDemos, (demo, idx) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "flex-row-box",
                    key: idx
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(demo.time), 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(demo.name), 1),
                    _createVNode(_component_el_button, {
                      type: "text",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createTextVNode("播放")
                      ])),
                      _: 1
                    })
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small"
      }, {
        default: _withCtx(() => _cache[23] || (_cache[23] = [
          _createTextVNode("认可训练效果")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        plain: ""
      }, {
        default: _withCtx(() => _cache[24] || (_cache[24] = [
          _createTextVNode("不认可,重新定制")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})